import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AuditLogsMobile from "../mobile/audit/AuditLogsMobile";
import AuditLogs from "./AuditLogs";
export default function ResponsiveAuditLogs(props) { return useIsMobile() ? <AuditLogsMobile {...props} /> : <AuditLogs {...props} />; }
